export default __webpack_public_path__ + "static/media/geplog.43f0b9b7.png";